export const REVIEWED_ITEMS_TITLE = 'My items';
export const REVIEWED_ITEMS_TITLE_ADMIN = 'All items';
export const PENDING_ITEMS_TITLE = 'Requests';
export const NO_PENDING_ITEMS_MESSAGE = 'There are no requests at this moment.';
